<div class="p-0 position-relative container-fluid page-background" [ngClass]="{ 'extend-page': extendPage }">
  <div class="d-none d-xl-block video-wrapper">
    <video class autoplay muted loop>
      <source [src]="desktopVideoUrl" type="video/mp4" />
    </video>
  </div>
  <div class="d-none d-md-block d-xl-none video-wrapper">
    <video autoplay muted loop>
      <source [src]="tabletVideoUrl" type="video/mp4" />
    </video>
  </div>
  <div class="d-md-none video-wrapper">
    <video autoplay muted loop>
      <source [src]="mobileVideoUrl" type="video/mp4" />
    </video>
  </div>
  <img class="logo" src="/assets/image/into-the-wild-logo.png" />
  <app-unauth-passport-form [showStamp]="showStamp"><ng-content></ng-content></app-unauth-passport-form>
</div>
